import { FaArrowLeft } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const PanelTopSecond = ({ link, actions }) => {
    return (
        <div
            className={`page-head page-head--actions-only flex flex-wrap items-center gap-2 ${actions ? 'justify-between' : 'justify-start'}`}
        >
            <NavLink
                to={link}
                title="Kembali"
                className="btn-secondary shrink-0 !min-h-9 !px-3"
            >
                <FaArrowLeft className="text-xs" />
                <span className="hidden sm:inline">Kembali</span>
            </NavLink>
            {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
        </div>
    );
};

export default PanelTopSecond;
